import { useState } from 'react'
import classes from './RelatedPatientsBox.module.css'
import classesCell from './BodyCell.module.css'
import { formatPatientName } from '../../../lib/patientName'

const RelatedPatientsBox = ({data}) => {
    const [modalOpen, setModalOpen] = useState(false)

    const mouseEnterHandler = () => {
        if (data && data.length > 0) {
            setModalOpen(true)
        }
        
    }

    const mouseLeaveHandler = () => {
        setModalOpen(false)
    }

    return <div className={`relative ${classesCell.body_cell}`} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
        {data && <>
            {data.length > 0 ? <div className={`${classes.number_box} ${(data && data.length > 0) ? classes.number_box_with_data : ''}`} >
                {data.length}
            </div> : ''}
        </>}
        {modalOpen && <div className={classes.modal_container}>
            {data && data.map(item => (
                <div key={item.id} className={classes.item}>
                    NG #{item.person_number} {formatPatientName(item)}
                </div>
            ))}
        </div>}
    </div>
}

export default RelatedPatientsBox